import { render } from "./NeoButton.vue?vue&type=template&id=67c3575e"
import script from "./NeoButton.vue?vue&type=script&lang=js"
export * from "./NeoButton.vue?vue&type=script&lang=js"

import "./NeoButton.vue?vue&type=style&index=0&id=67c3575e&lang=scss"

import exportComponent from "/var/www/html/neo-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__